import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import masterData from './modules/master-data'
import users from './modules/users'
import workflow from './modules/workflow'
import report from './modules/report'
import dashboard from './modules/dashboard'
import admin from './modules/admin'
import menu from './modules/menu'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    masterData,
    users,
    workflow,
    report,
    dashboard,
    admin,
    menu
  },
  plugins: [createPersistedState()],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js